<template>
  <div class="">
    <policy-transfer />
  </div>
</template>

<script>
import PolicyTransfer from "@/components/wallet/policies/transfer.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    PolicyTransfer,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Voltura Polizza",
        path: "insurance_policies.transfer",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Voltura Polizza",
        path: "insurance_policies.transfer",
        level: 3,
      });
    }
  },
};
</script>
